import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { environment } from '@environments/environment';

@Injectable({ providedIn: 'root' })
export class VoucherService {
    constructor(private http: HttpClient) { }

    getVouchers(params?) {
        return this.http.get<any[]>(`${environment.apiUrl}/vouchers/`);
    }
}